var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"height":"350px"}},[_c('l-map',{staticStyle:{"height":"80vh","width":"100wh"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-marker',{attrs:{"lat-lng":_vm.markerlat}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }